var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.085,
    viewBox: "0 0 20 17.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1546.094,78.992a1.541,1.541,0,0,1,.791-.1,1.509,1.509,0,0,1,.717.307,1.431,1.431,0,0,1,.462.632,1.4,1.4,0,0,1,.09.782L1545.9,94.3a1.97,1.97,0,0,1-2.881,1.42c-1.015-.55-2.522-1.4-3.866-2.283-.687-.443-2.761-1.861-2.508-2.87.224-.863,3.7-4.1,5.7-6.032.776-.757.418-1.194-.507-.5-2.284,1.729-5.956,4.359-7.179,5.1a3.063,3.063,0,0,1-2.3.653,14.921,14.921,0,0,1-3.269-.9,1.479,1.479,0,0,1-.015-2.732Z",
    transform: "translate(-1528.173 -78.875)",
    fill: "#34a9e5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.230365457de40e960eba6be4fa209b26.svg";
export { ForwardRef as ReactComponent };